import React, { useState, useEffect } from 'react';

const TeacherCard = ({ teacher, isEven }) => {
  const [imageError, setImageError] = useState(false);
  const [imageSrc, setImageSrc] = useState(teacher.photo);
  
  // Check if image exists on load
  useEffect(() => {
    const img = new Image();
    img.src = teacher.photo;
    
    img.onload = () => {
      setImageSrc(teacher.photo);
      setImageError(false);
    };
    
    img.onerror = () => {
      console.error(`Failed to load image: ${teacher.photo}`);
      setImageError(true);
    };
  }, [teacher.photo]);

  return (
    <div className="teacher-section" style={{ flexDirection: isEven ? 'row' : 'row-reverse' }}>
      <div className="teacher-image">
        <div className="teacher-image-square">
          {imageError ? (
            <div className="image-placeholder">Obrázek nenalezen</div>
          ) : (
            <img 
              src={imageSrc} 
              alt={teacher.name}
              onError={() => setImageError(true)}
            />
          )}
        </div>
      </div>
      <div className="teacher-info">
        <h2>{teacher.name}</h2>
        <p>{teacher.bio}</p>
      </div>
    </div>
  );
};

export default TeacherCard; 